import { render, staticRenderFns } from "./groupedpromotions-list.vue?vue&type=template&id=650a550d&"
import script from "./groupedpromotions-list.vue?vue&type=script&lang=js&"
export * from "./groupedpromotions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports